// import {UserTypeDict} from '../../../utils/settings';

const Reducer = (
  state = {
    company_id: null,
    buyer: {},
    giftProduct: null,
    showOrderTab: false,
  },
  action,
) => {
  switch (action.type) {
    case 'SET_COMPANY_ID':
      return { ...state, company_id: action.data };
    case 'SET_BUYER':
      return { ...state, buyer: action.data };
    case 'SET_GIFT_PRODUCT':
      return { ...state, giftProduct: action.data };
    case 'SET_ORDER_TAB_TRUE':
      return { ...state, showOrderTab: true };
    default:
      return state;
  }
};

export default Reducer;
